import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useLocale } from '@/modules/locale/model/locale';
import { ROUTE_NAME_PROGRESS } from '@/modules/progress/router';
import { progressService } from '@/services/progress';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useProgressLevelTranslate() {
    const router = useAppRouter();
    const route = useRoute();
    const crudAction = useCrudActions();

    const { localeSupportedOptions, getListSupported } = useLocale();

    const model = reactive({
        progressId: route.params.progressId,
        level: route.params.level,
        locale: null,
        title: '',
        description: '',
        hasData: false
    });

    const validations = {
        title: { required },
        locale: { required },
        description: {}
    };

    const v$ = useVuelidate(validations, model);

    const beforeFetch = async () => {
        await getListSupported();
        if (!localeSupportedOptions.value.length) {
            router.push({ name: ROUTE_NAME_PROGRESS.LEVEL.INDEX, params: { progressId: model.progressId } });
            return;
        }
    };

    const fetch = crudAction.executeAction({
        canExecute: () => model.locale != null,
        request: () => progressService.level.getText(model.progressId, model.level, model.locale),
        onSuccess: ({ data }) => {
            model.hasData = true;
            model.title = data.title;
            model.description = data.description;
        },
        onError: () => {
            model.hasData = false;
            model.title = '';
            model.description = '';
        },
        onFinally: () => v$.value.$reset()
    });

    const actions = {
        updateText: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                progressService.level.updateText(
                    model.progressId,
                    model.level,
                    model.locale,
                    model.title,
                    model.description
                ),
            onSuccess: fetch
        }),
        removeText: crudAction.confirmAndRemove({
            request: () => progressService.level.removeText(model.progressId, model.level, model.locale),
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, beforeFetch, actions, localeSupportedOptions };
}
